// @flow
import * as React from 'react';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import TargetByStudentIdContainer from './TargetByStudentIdContainer';
import TargetByStudentIdPanel from './TargetByStudentIdPanel';

import type { TargetByStudentIdPages } from './SelectRecipientPanel';

type Props = {
  onContinue: () => void,
  onPageChange: (page: TargetByStudentIdPages) => void,
  schools: ?($Shape<ComposerOrganization>[]),
  studentIdListRecipientInSelection: ?StudentIdListRecipient,
};

export default class TargetByStudentId extends React.Component<Props, *> {
  render() {
    if (!this.props.schools) {
      return <CenteredLoadingIndicator />;
    }

    const schoolUuids = this.props.schools.map(school => school.uuid);
    return (
      <TargetByStudentIdContainer schoolUuids={schoolUuids}>
        {props => (
          <TargetByStudentIdPanel
            {...props}
            onContinue={this.props.onContinue}
            onPageChange={this.props.onPageChange}
            studentIdListRecipientInSelection={this.props.studentIdListRecipientInSelection}
          />
        )}
      </TargetByStudentIdContainer>
    );
  }
}
